import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

// MODULES
import auth from './auth/auth.module';
import nav from './nav/nav.module';
import rtps from './rtps/rtps.module';
import pa from './pa/pa.module';
import offer from './offer/offer.module';
import error from './error/error.module';
import copayepasource from './copay-epa-source/copayepasource.module';
import da from './dataoverride/dataoverride.module';
import prescribercrosswalk from './prescriber-crosswalk/prescriber-crosswalk.module';
import denialcodemap from './denial-code-map/denial-code-map.module';
import brandlimit from './brand-limit/brand-limit.module';

// CONSTANTS
import { SAVE_RTPS_EXPORT_FIELDS } from './rtps/rtps.mutations';
import { SAVE_PA_EXPORT_FIELDS } from './pa/mutations.type';
import { SET_MENU_ITEMS } from './nav/nav.mutations';
import { SET_PROFILE, SET_ACCESS_TOKEN, SET_ID_TOKEN, SET_VERIFICATION, SET_AUTHENTICATED, SET_GROUPS } from './auth/auth.mutations';

Vue.use(Vuex);

// Modules
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({
    auth: state.auth,
    nav: state.nav,
    rtps: state.rtps,
    pa: state.pa,
    prescribercrosswalk: state.prescribercrosswalk,
    denialcodemap: state.denialcodemap,
    brandlimit: state.brandLimit
  }),
  filter: mutation => (mutation.type === SET_PROFILE ||
    mutation.type === SET_ACCESS_TOKEN ||
    mutation.type === SET_ID_TOKEN ||
    mutation.type === SET_AUTHENTICATED ||
    mutation.type === SET_VERIFICATION ||
    mutation.type === SET_GROUPS ||
    mutation.type === SET_MENU_ITEMS ||
    mutation.type === SAVE_RTPS_EXPORT_FIELDS ||
    mutation.type === SAVE_PA_EXPORT_FIELDS)
});

const store = new Vuex.Store({
  modules: {
    auth,
    rtps,
    nav,
    pa,
    offer,
    error,
    copayepasource,
    da,
    prescribercrosswalk,
    denialcodemap,
    brandlimit
  },
  plugins: [vuexLocal.plugin]
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js